export default __webpack_public_path__ + "static/media/Helm of the Living Tarim.1b69931a.jpg";